import React from "react";
//import { Redirect } from 'react-router-dom'
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";

import Currency from "react-currency-formatter";
import cogoToast from 'cogo-toast';


import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import { ReactComponent as StarIcon } from "images/star-icon.svg";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg-decorator-blob-5.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "images/svg-decorator-blob-7.svg";

import { 
  setTabAction,
  addToBasket,
  loadStocksFromFirestore
} from "../../services/actions";
import { fetchServedStates } from "DBServices/firestoreDBService";
//import { fetchMarketData } from "../../services/backendCalls";
//import { PrimaryButton } from "components/misc/Buttons";

import TailwindModal from 'components/modals/TailwindModal'
//use async directly in js
//set state on stateless comp

const HeaderRow = tw.div`flex justify-between items-center flex-col xl:flex-row`;
const Header = tw(SectionHeading)``;
const TabsControl = tw.div`flex flex-wrap bg-gray-100 p-2 rounded-xl leading-none mt-12 xl:mt-0 border border-gray-200`;

const TabControl = styled.div`
  ${tw`cursor-pointer px-6 py-3 mt-2 sm:mt-0 sm:mr-2 last:mr-0 text-gray-600 font-bold rounded-lg transition duration-200 text-sm sm:text-base w-1/2 sm:w-auto text-center`}
  &:hover {
    ${tw`bg-gray-200 text-gray-800`}
  }
  ${props => props.active && `background-color: #047857 !important; color: white !important; box-shadow: 0 1px 2px rgba(0,0,0,0.1);`}
  }
`;

const TabContent = tw(motion.div)`mt-6 flex flex-wrap sm:-mr-10 md:-mr-6 lg:-mr-12`;
export const CardContainer = tw.div`mt-10 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 sm:pr-10 md:pr-6 lg:pr-12`;
export const Card = tw(motion.a)`bg-white border border-gray-100 rounded-2xl block max-w-xs mx-auto sm:max-w-none sm:mx-0 shadow-sm hover:shadow-xl hover:-translate-y-1 transform transition duration-300 overflow-hidden cursor-pointer`;
export const CardImageContainer = styled.div`
  ${props => css`background-image: url("${props.imageSrc}");`}
  ${tw`h-56 xl:h-64 bg-center bg-cover relative rounded-t-2xl`}
`;
export const CardRatingContainer = tw.div`leading-none absolute inline-flex bottom-0 left-0 ml-4 mb-4 rounded-full px-4 py-2 items-center shadow-sm border border-gray-100 bg-white`;
export const CardRating = styled.div`
  ${tw`mr-1 text-sm font-bold flex items-center text-gray-800`}
  svg {
    color: #f59e0b;
    ${tw`w-4 h-4 fill-current mr-1`}
  }
`;

export const CardHoverOverlay = styled(motion.div)`
  background-color: rgba(2, 44, 34, 0.6);
  backdrop-filter: blur(2px);
  ${tw`absolute inset-0 flex justify-center items-center`}
`;
export const CardButton = styled(PrimaryButtonBase)`
  ${tw`text-xs font-bold uppercase tracking-wider rounded-full border-0 py-2 px-6 shadow transition duration-200`}
  background: linear-gradient(to right, #fbbf24, #f59e0b);
  color: #111827;
  &:hover {
    background: linear-gradient(to right, #f59e0b, #d97706);
  }
`;

export const CardReview = tw.div`font-medium text-xs text-gray-500 ml-1`;

export const CardText = tw.div`p-5 text-gray-800 border-t-0 bg-white rounded-b-2xl`;
export const CardTitle = tw.h5`text-lg font-bold text-gray-800 transition-colors duration-150`;
export const CardContent = tw.p`mt-2 text-xs font-medium text-gray-500 leading-relaxed`;
export const CardPrice = tw.p`mt-4 text-xl font-black text-green-800`;

const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none -z-20 absolute right-0 top-0 h-64 w-64 opacity-10 transform translate-x-2/3 text-pink-400`}
  margin-top: -3rem;
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none -z-20 absolute left-0 bottom-0 h-80 w-80 opacity-10 transform -translate-x-2/3 text-green-500`}
`;
const Instruction = tw(SubheadingBase)`text-base text-left text-gray-600 mt-2 mb-8 max-w-3xl`;

// State / Neighborhood filter controls (served-area selection)
const FilterSelect = tw.select`border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-green-600 bg-white text-gray-700 transition`;
const LocationFilterWrap = tw.div`flex flex-wrap gap-3 mt-4`;
const ActiveFilterChip = styled.button`
  ${tw`inline-flex items-center gap-2 mt-4 px-3 py-1 rounded-full text-sm font-semibold transition`}
  background-color: #d1fae5;
  color: #047857;
  &:hover { background-color: #a7f3d0; }
  span.x { ${tw`font-black`} }
`;

const ButtonContainer = tw.div`flex justify-center p-0`;
//const LoadMoreButton = tw(PrimaryButton)`mt-16 mx-auto`;
const LoadMoreButton = tw(motion.a)`h-auto w-auto p-20 text-center mt-16 mx-auto px-8 py-3 font-bold rounded bg-green-500 text-gray-100 cursor-pointer hocus:bg-primary-700 hocus:text-gray-200 focus:shadow-outline focus:outline-none transition duration-300`;
const MarketplaceContent = styled(ContentWithPaddingXl)`
  ${props => props.compact && css`
    padding-top: 1.5rem;
  `}
`;

const EmptyStateBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 56px 24px;
  margin: 24px auto;
  background-color: #f9fafb;
  border: 2px dashed #e5e7eb;
  border-radius: 16px;
  text-align: center;
  box-sizing: border-box;
`;

const EmptyStateIcon = styled.div`
  font-size: 44px;
  margin-bottom: 14px;
  line-height: 1;
`;

const EmptyStateTitle = styled.h4`
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
`;

const EmptyStateDescription = styled.p`
  font-size: 0.95rem;
  color: #6b7280;
  max-width: 460px;
  margin: 0 0 20px 0;
  line-height: 1.5;
`;

const ClearFilterButton = styled.button`
  background-color: #047857;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 10px 22px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  &:hover {
    background-color: #065f46;
  }
`;





class TCGComponent extends React.Component {
  /*
   * To customize the tabs, pass in data using the `tabs` prop. It should be an object which contains the name of the tab
   * as the key and value of the key will be its content (as an array of objects).
   * To see what attributes are configurable of each object inside this array see the example above for "Starters".
  */  
   /* constructor(props) {
    super(props);
  
    this.state = {
      products: [],
    };

    //this.handleUpVote = this.handleUpVote.bind(this);
  }
*/
/*
state = {
  shouldRedirect: false
}

onLoadMoreClick = () => {
  this.setState({shouldRedirect: true});
}
*/
//const [toggleOneModal, setToggleOneModal] = useState(false);
//const [toggleTwoModal, setToggleTwoModal] = useState(false);

state = {
  showModal: false,
  product: {},
  visibleCount: 20,
  servedStates: [],
  neighborhoodsByState: {},
  allNeighborhoods: [],
  selectedState: "",
  selectedNeighborhood: ""
}

setShowModal = (booleanState, product) => this.setState({...this.state, showModal: booleanState, product})
/* setProduct = (product) => {
  console.log(product)
  this.setState({...this.state, product})
} */


  loadMore = (e, card) => {
    const activeTab = this.props.TabCardGridData?.activeTab;

    if (activeTab === 'Category' && card) {
      const cat = card.queryBy || card.title || '';
      this.props.onClick('Foods');
      this.props.history.push(`/marketplace?page=stock&tab=Foods&cat=${encodeURIComponent(cat)}`);
      return;
    }

    if (activeTab === 'Market' && card) {
      // Use the market's Firestore id (which equals food.partnerMarketId) so the
      // marketplace filter can match foods belonging to this market.
      const marketValue = card.firestoreId || card.marketId || card.partnerMarketId || card.queryBy || card.title || '';
      this.props.onClick('Foods');
      this.props.history.push(`/marketplace?page=stock&tab=Foods&market=${encodeURIComponent(marketValue)}`);
      return;
    }

    if (this.props.page === 'stock') {
      if (e && e.preventDefault) e.preventDefault();
      this.setState((prevState) => ({ visibleCount: prevState.visibleCount + 20 }));
      return;
    }
    this.props.history.push('/marketplace?page=stock')
  }

addItemToBasket = (product) => {
  //if (!product?.id) return
  //const items = this.props.TabCardGridData?.items;
  //const item = items?.find((item) => item.id === product?.id)
  
  // if (item?.id) {
  //   cogoToast.warn('Product already added! Please, go to basket to complete purchase.')
  //   return
  // }
  
  this.props.addItemToBasketDispatch(product)
}

/* componentDidMount() {      
  this.props.fetchMainStocks();
} */

// Ensure the Redux active tab matches the ?tab= URL param so filters that only
// run on the Foods tab (cat / market / q) actually apply when arriving via a
// search result, buy form, or category/market link.
syncTabFromUrl = () => {
  const urlParams = new URLSearchParams(this.props.location?.search || "");
  const tabParam = urlParams.get('tab');
  const tabs = this.props.TabCardGridData?.tabs || {};
  if (tabParam && tabs[tabParam] && this.props.TabCardGridData?.activeTab !== tabParam) {
    this.props.onClick(tabParam);
  }
}

componentDidMount() {
  // stocks are loaded once at app boot in index.js — no need to reload here

  // Apply the ?tab= param (e.g. from a homepage search result) to the active tab.
  this.syncTabFromUrl();

  // Initialise served-area filters from URL params (e.g. set by the homepage
  // buy form) and load the admin-managed served states / neighborhoods.
  const urlParams = new URLSearchParams(this.props.location?.search || "");
  const initState = urlParams.get('state') || "";
  const initNeighborhood = urlParams.get('neighborhood') || "";

  fetchServedStates()
    .then((data) => {
      const states = Array.isArray(data) ? data : [];
      const neighborhoodsByState = {};
      const allNeighborhoods = [];
      states.forEach((s) => {
        neighborhoodsByState[s.name] = Array.isArray(s.neighborhoods) ? s.neighborhoods : [];
        (s.neighborhoods || []).forEach((n) => {
          if (!allNeighborhoods.includes(n)) allNeighborhoods.push(n);
        });
      });
      this.setState({
        servedStates: states,
        neighborhoodsByState,
        allNeighborhoods,
        selectedState: initState,
        selectedNeighborhood: initNeighborhood,
      });
    })
    .catch((e) => console.error("TabCardGrid served-states load failed:", e));
}

componentDidUpdate(prevProps) {
  // When the URL query changes (e.g. a new search result is clicked while
  // already on the marketplace), re-apply the ?tab= param and reset paging.
  if (prevProps.location?.search !== this.props.location?.search) {
    this.syncTabFromUrl();
    this.setState({ visibleCount: 20 });
  }
  if (prevProps.page !== this.props.page || prevProps.TabCardGridData?.activeTab !== this.props.TabCardGridData?.activeTab) {
    this.setState({ visibleCount: 20 });
  }
}

handleStateChange = (e) => {
  const value = e.target.value;
  const { neighborhoodsByState } = this.state;
  const nextNeighborhoods = neighborhoodsByState[value] || [];
  this.setState({ selectedState: value, selectedNeighborhood: "" });
  this.syncLocationParams(value, nextNeighborhoods[0] || "");
};

handleNeighborhoodChange = (e) => {
  const value = e.target.value;
  this.setState({ selectedNeighborhood: value });
  this.syncLocationParams(this.state.selectedState, value);
};

// Keep the ?state=&neighborhood= params in the URL in sync so the selection
// persists across navigation (e.g. when arriving from the homepage buy form).
syncLocationParams = (stateValue, neighborhoodValue) => {
  if (!this.props.history || typeof this.props.history.replace !== "function") return;
  const params = new URLSearchParams(this.props.location?.search || "");
  if (stateValue) params.set("state", stateValue); else params.delete("state");
  if (neighborhoodValue) params.set("neighborhood", neighborhoodValue); else params.delete("neighborhood");
  const qs = params.toString();
  this.props.history.replace(`${this.props.location?.pathname || "/marketplace"}${qs ? `?${qs}` : ""}`);
};
  
  // Clear the search / category / market filter params from the URL so the full
// marketplace is shown again.
clearSearchFilter = () => {
  const params = new URLSearchParams(this.props.location?.search || "");
  ['q', 'cat', 'market', 'prod_type'].forEach((k) => params.delete(k));
  const qs = params.toString();
  this.props.history.push(`${this.props.location?.pathname || "/marketplace"}${qs ? `?${qs}` : ""}`);
  this.setState({ visibleCount: 20 });
}

clearAllFilters = () => {
  const params = new URLSearchParams(this.props.location?.search || "");
  ['q', 'cat', 'market', 'prod_type', 'state', 'neighborhood'].forEach((k) => params.delete(k));
  this.setState({ selectedState: "", selectedNeighborhood: "", visibleCount: 20 });
  const qs = params.toString();
  this.props.history.push(`${this.props.location?.pathname || "/marketplace"}${qs ? `?${qs}` : ""}`);
}

render() {    
    const items = this.props.TabCardGridData?.items;
    const activeTab = this.props.TabCardGridData?.activeTab || '';
    const page = this.props.page || '';
    let tabs = this.props.TabCardGridData?.tabs || {};
    const heading = this.props.TabCardGridData?.heading || '';
    const visibleCount = this.state.visibleCount || 20;

    // -- Marketplace Filtering Logic --
    const urlParams = new URLSearchParams(this.props.location?.search || "");
    const catParam = urlParams.get('cat');
    const marketParam = urlParams.get('market');
    const prodTypeParam = urlParams.get('prod_type');
    const qParam = urlParams.get('q');

    if (activeTab === 'Foods' && (catParam || marketParam || prodTypeParam || qParam)) {
      const foods = tabs['Foods'] || [];
      const catNorm = (catParam || '').replace(/[_\s]+/g, '').toLowerCase();
      const marketNorm = (marketParam || '').replace(/[_\s]+/g, '').toLowerCase();
      const prodNorm = (prodTypeParam || '').replace(/[_\s]+/g, '').toLowerCase();
      const qNorm = (qParam || '').replace(/[_\s]+/g, '').toLowerCase();
      
      const catMap = {};
      (tabs['Category'] || []).forEach(c => {
        if (c.firestoreId) {
          catMap[c.firestoreId] = (c.queryBy || c.title || c.name || '').replace(/[_\s]+/g, '').toLowerCase();
        }
      });

      const filteredFoods = foods.filter(p => {
        const titleNorm = (p.title || p.name || '').replace(/[_\s]+/g, '').toLowerCase();
        const contentNorm = (p.content || '').replace(/[_\s]+/g, '').toLowerCase();
        const contentArrayNorm = (p.contentArray || []).join(' ').replace(/[_\s]+/g, '').toLowerCase();
        const pCatNorm = (p.category || p.categoryName || p.marketCategory || '').replace(/[_\s]+/g, '').toLowerCase();
        
        let matchesCat = true;
        let matchesMarket = true;
        let matchesProd = true;
        let matchesQ = true;

        if (catNorm) {
           let catIdsMatch = false;
           if (Array.isArray(p.categories)) {
             catIdsMatch = p.categories.some(id => catMap[id] && catMap[id].includes(catNorm));
           }
           matchesCat = catIdsMatch || titleNorm.includes(catNorm) || contentNorm.includes(catNorm) || contentArrayNorm.includes(catNorm) || pCatNorm.includes(catNorm);
        }
         if (marketNorm) {
            // Foods reference their market via partnerMarketId/marketId (the market's
            // Firestore id). Match that exactly, and fall back to name-based matching.
            const pMarketId = (p.marketId || p.partnerMarketId || '').toLowerCase();
            const pMarketName = (p.marketName || p.title || p.name || '').replace(/[_\s]+/g, '').toLowerCase();
            matchesMarket =
              pMarketId === marketNorm ||
              pMarketName.includes(marketNorm) ||
              titleNorm.includes(marketNorm) ||
              contentNorm.includes(marketNorm);
         }
        if (prodNorm) {
           matchesProd = titleNorm.includes(prodNorm) || contentNorm.includes(prodNorm) || contentArrayNorm.includes(prodNorm);
        }
        if (qNorm) {
           const pMarketNameNorm = (p.marketName || '').replace(/[_\s]+/g, '').toLowerCase();
           matchesQ =
             titleNorm.includes(qNorm) ||
             contentNorm.includes(qNorm) ||
             contentArrayNorm.includes(qNorm) ||
             pCatNorm.includes(qNorm) ||
             pMarketNameNorm.includes(qNorm);
        }
        return matchesCat && matchesMarket && matchesProd && matchesQ;
      });

      tabs = { ...tabs, Foods: filteredFoods };
    }
    // -- End Marketplace Filtering --

    // -- Served-Area (State / Neighborhood) Filtering --
    // Admin-managed states with their neighborhoods drive these filters. Items
    // that have no location metadata are treated as available in every area so
    // the grid never breaks when products aren't tagged with an area yet.
    const { selectedState, selectedNeighborhood } = this.state;
    const hasLocationFilter = !!(selectedState || selectedNeighborhood);
    if (hasLocationFilter) {
      const matchesLocation = (item) => {
        const hasMeta = item.state || item.neighborhood || Array.isArray(item.neighborhoods);
        if (!hasMeta) return true;
        const stateOk = !selectedState || item.state === selectedState;
        const nbOk = !selectedNeighborhood ||
          item.neighborhood === selectedNeighborhood ||
          (Array.isArray(item.neighborhoods) && item.neighborhoods.includes(selectedNeighborhood)) ||
          item.state === selectedState;
        return stateOk && nbOk;
      };
      Object.keys(tabs).forEach((key) => {
        if (Array.isArray(tabs[key])) {
          tabs = { ...tabs, [key]: tabs[key].filter(matchesLocation) };
        }
      });
    }
    // -- End Served-Area Filtering --

    const tabsKeys = Object.keys(tabs);
    const hasMoreItems = Object.values(tabs).some((tabItems) => Array.isArray(tabItems) && tabItems.length > visibleCount);

    // Label for the active search/category/market filter (shown as a removable chip).
    const activeFilterLabel = qParam
      ? `Search: "${qParam}"`
      : catParam
      ? `Category: ${catParam}`
      : marketParam
      ? `Market: ${marketParam}`
      : prodTypeParam
      ? `Type: ${prodTypeParam}`
      : "";
  
  return (    
    
    <Container id="bf">
      <MarketplaceContent compact={page === 'stock'}>
        <HeaderRow>
          <div>
            <Header>{page === 'stock' ? 'Welcome to our marketplace' : heading}</Header>
            <Instruction>{page === 'stock' ? 'Click to add to your shopping basket. Complete purchase in the shopping basket.' : 'Click to Go to the market'}</Instruction>
            {activeFilterLabel && (
              <ActiveFilterChip onClick={this.clearSearchFilter} title="Clear filter">
                {activeFilterLabel}
                <span className="x">&times;</span>
              </ActiveFilterChip>
            )}
            <LocationFilterWrap>
              <FilterSelect
                value={this.state.selectedState}
                onChange={this.handleStateChange}
              >
                <option value="">All States</option>
                {this.state.servedStates.map((s) => (
                  <option key={s.firestoreId || s.name} value={s.name}>{s.name}</option>
                ))}
              </FilterSelect>
              <FilterSelect
                value={this.state.selectedNeighborhood}
                onChange={this.handleNeighborhoodChange}
                disabled={!this.state.selectedState}
              >
                <option value="">
                  {!this.state.selectedState
                    ? "Select a state first"
                    : (this.state.neighborhoodsByState[this.state.selectedState] || []).length === 0
                    ? "No neighborhoods for this state"
                    : "All Neighborhoods"}
                </option>
                {(this.state.selectedState
                  ? (this.state.neighborhoodsByState[this.state.selectedState] || [])
                  : this.state.allNeighborhoods).map((n) => (
                  <option key={n} value={n}>{n}</option>
                ))}
              </FilterSelect>
            </LocationFilterWrap>
          </div>
          <TabsControl>
            {Object.keys(tabs).map((tabName, index) => (
              <TabControl key={index} active={activeTab === tabName} onClick={() => this.props.onClick(tabName)}>
                {tabName}
              </TabControl>
            ))}
          </TabsControl>
        </HeaderRow>

        {tabsKeys.map((tabKey, index) => {
          const tabItems = tabs[tabKey] || [];
          const hasFilter = !!(activeFilterLabel || hasLocationFilter);

          return (
            <TabContent
              key={index}
              variants={{
                current: {
                  opacity: 1,
                  scale: 1,
                  display: "flex",
                },
                hidden: {
                  opacity: 0,
                  scale: 0.8,
                  display: "none",
                }
              }}
              transition={{ duration: 0.4 }}
              initial={activeTab === tabKey ? "current" : "hidden"}
              animate={activeTab === tabKey ? "current" : "hidden"}
            >
              {tabItems.length === 0 ? (
                <EmptyStateBox>
                  <EmptyStateIcon>
                    {tabKey === 'Foods' ? '🥗' : tabKey === 'Market' ? '🏪' : tabKey === 'Category' ? '🏷️' : '📦'}
                  </EmptyStateIcon>
                  <EmptyStateTitle>
                    {hasFilter ? `No ${tabKey} match your filters` : `No ${tabKey} listed yet`}
                  </EmptyStateTitle>
                  <EmptyStateDescription>
                    {hasFilter
                      ? 'No items matched your selected search or location filter. Clear your filters to browse everything.'
                      : `There are currently no ${tabKey.toLowerCase()} available. Check back soon as new items are added regularly.`}
                  </EmptyStateDescription>
                  {hasFilter && (
                    <ClearFilterButton type="button" onClick={this.clearAllFilters}>
                      Clear All Filters
                    </ClearFilterButton>
                  )}
                </EmptyStateBox>
              ) : (
                tabItems.slice(0, page === 'stock' ? visibleCount : 20).map((card, cardIndex) => (
                  <CardContainer key={cardIndex}>
                    <Card className="group" onClick={() => this.loadMore(null, card)} initial="rest" whileHover="hover" animate="rest">{/*components/innerPages/SignupPage?tab=${activeTab}&cat=${card.content}&prod=${card.queryBy}*/}
                      <CardImageContainer imageSrc={card?.imageSrc}>
                        <CardRatingContainer>
                          <CardRating>
                            <StarIcon />
                            {card?.rating}
                          </CardRating>
                          <CardReview>({card?.reviews})</CardReview>
                        </CardRatingContainer>
                        <CardHoverOverlay
                          variants={{
                            hover: {
                              opacity: 1,
                              height: "auto"
                            },
                            rest: {
                              opacity: 0,
                              height: 0
                            }
                          }}
                          transition={{ duration: 0.3 }}
                        >
                          <CardButton onClick={(e) => {
                            const activeTab = this.props.TabCardGridData?.activeTab;

                            if (activeTab === 'Category') {
                              e && e.stopPropagation && e.stopPropagation();
                              const cat = card.queryBy || card.title || '';
                              this.props.onClick('Foods');
                              this.props.history.push(`/marketplace?page=stock&tab=Foods&cat=${encodeURIComponent(cat)}`);
                              return;
                            }

                            if (activeTab === 'Market') {
                              e && e.stopPropagation && e.stopPropagation();
                              const marketValue = card.firestoreId || card.marketId || card.partnerMarketId || card.queryBy || card.title || '';
                              this.props.onClick('Foods');
                              this.props.history.push(`/marketplace?page=stock&tab=Foods&market=${encodeURIComponent(marketValue)}`);
                              return;
                            }

                            if (page === 'stock') {
                              e && e.stopPropagation && e.stopPropagation();
                              cogoToast.info('Swipe screen or use the side arrow buttons to change types...')
                              this.setShowModal(true, card)
                              return;
                            }
                          }}>
                            {activeTab === 'Category' ? 'Filter by this category' : activeTab === 'Market' ? 'Go to market' : (page === 'stock' ? 'Add to Basket' : 'Go to Market')}
                          </CardButton> {/*href={`/components/innerPages/SignupPage?tab=${activeTab}&cat=${card.content}&prod=${card.queryBy}`} */}                      
                        </CardHoverOverlay>
                      </CardImageContainer>
                      <CardText>
                        <CardTitle>{card?.title}</CardTitle>
                        <CardContent>{card?.content}</CardContent>
                        {activeTab !== 'Category' && activeTab !== 'Market' && (
                          <CardPrice>From &#8358;{card?.price}</CardPrice>
                        )}
                      </CardText>
                    </Card>
                  </CardContainer>
                ))
              )}
            </TabContent>
          );
        })}        
        {tabs[activeTab]?.length > 0 && (
          <ButtonContainer>
            {page === 'stock' && hasMoreItems ? (
              <LoadMoreButton onClick={this.loadMore}>Load More...</LoadMoreButton>
            ) : (
              <LoadMoreButton onClick={this.loadMore}>{page === 'stock' ? 'See More...' : 'Visit Market...'}</LoadMoreButton>
            )}
          </ButtonContainer>
        )}
      </MarketplaceContent>
      <DecoratorBlob1 />
      <DecoratorBlob2 />
      <TailwindModal 
        showModal={this.state.showModal}
        setShowModal={this.setShowModal}
        product={this.state.product}
        addItemToBasket={this.addItemToBasket}
        items={items}
      />
    </Container>    
  );
}}

const TabCardGrid = connect((state) => ({
  TabCardGridData: state.TabCardGridData
}), (dispatch) => ({
  loadStocks: () => dispatch(loadStocksFromFirestore()),
  onClick: (tabName) => {
    dispatch(setTabAction(tabName));
  },
  addItemToBasketDispatch: (product) => {
     
    if (Object.keys(product).length) {
      dispatch(addToBasket(product))
      //cogoToast.success('Product added! Please, go to basket to complete purchase.')
    }
  }     
})/* , (_, mapProps, dispatchProps) => ({
  addItemToBasket: (id) => {
    if (!id) return
    const items = mapProps?.TabCardGridData?.items;
    const product = items?.find((item) => item.id === id)
    if (product?.id) {
        cogoToast.warn('Product already added! Please complete purchase in basket.')
        return
    }  
    if (Object.keys(product).length) {
        dispatchProps.addToBasketDispatch(product)
        cogoToast.success('Product added!')
    }
  }
}) */
)(TCGComponent);

export default withRouter(TabCardGrid)